<template>
	<div>
    <h1 class="question">{{ question.title }}（多选）</h1>
    <li class="option" :class="{'checked':selectedItems.indexOf(item)>-1}" v-for="item in question.options" @click="select(item)"> {{ item.text }} </li>
    <div class="next-btn" :class="{'disable':selectedItems.length==0}" @click="goNext">下一题</div>
  </div>
</template>
<script>
  export default {
    methods: {
      select: function (option) {
        var index = this.selectedItems.indexOf(option)
        index > -1 ? this.selectedItems.splice(index, 1) : this.selectedItems.push(option)
      },
      goNext: function () {
        var score = 0
        var answerLength = this.selectedItems.length
        if (answerLength === 0) {
          return false
        }
        var answers = []
        this.selectedItems.forEach(function (option, index) {
          score += answerLength > 1 && option.score < 0 ? 0 : option.score
          answers.push(option.aId)
        })
        var answerObj = {}
        answerObj[this.question.qId] = answers.join(',')
        this.$dispatch('changeView', 'q7', score, answerObj)
        this.selectedItems = []
      }
    },
    data () {
      return {
        question: {
          title: '您可以提供以下哪些联系方式',
          qId: 'q6',
          options: [{
            text: '个人手机',
            score: -2,
            aId: 'a1'
          }, {
            text: '家庭固话',
            score: 2,
            aId: 'a2'
          }, {
            text: '单位固话',
            score: 5,
            aId: 'a3'
          }]
        },
        selectedItems: []
      }
    }
}

</script>

<style scoped>
.question{
      background: url(../assets/question_icon.png) no-repeat;
      font-weight: normal;
      padding-left: 3.5rem;
      background-size: 2.5rem 2rem;
      font-size: 2rem;
      margin: 2rem 1rem;
      color:#333;
  }
  .option{
      list-style: none;
      font-size: 1.5rem;
      padding: 1.2rem 3.5rem;
      margin: 0.8rem 0;
      color:#666;
      background: url(../assets/list_point.png) no-repeat  #fff;
      background-size: 0.4rem;
      background-position: 2rem 2rem;
  }
  .option.checked{
      background-image: url(../assets/checkmark.png);
      background-size: 1rem 1rem;
      background-position: 2rem 1.8rem;
  }
  .next-btn{
      width: 80%;
      margin: 1.5rem auto 0;
      text-align: center;
      background: #d94b40;
      font-size: 1.5rem;
      padding: 1rem;
      color: #fff;
      border-radius: 0.5rem;
      font-weight: normal;
}
.next-btn.disable{
  background: #F9AFA9;
}
</style>



/** WEBPACK FOOTER **
 ** q6.vue?0fe79766
 **/